import { render, staticRenderFns } from "./DashboardRevenue.vue?vue&type=template&id=25a8b290&"
import script from "./DashboardRevenue.vue?vue&type=script&lang=js&"
export * from "./DashboardRevenue.vue?vue&type=script&lang=js&"
import style0 from "./DashboardRevenue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports